import { useState } from "react"

const useAbsenceDrawerAlerts = () => {

  const [alertMessage, setAlertMessage] = useState<string>()
  const [alertComponentId, setAlertComponentId] = useState<number>(0)
  const [hasConflict, setHasConflict] = useState<boolean>(false)

  return {
    alertMessage,
    setAlertMessage,
    alertComponentId,
    setAlertComponentId,
    hasConflict,
    setHasConflict,
  }
}

export default useAbsenceDrawerAlerts